import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientBillDynamicGroupablesProps<T> = {
  companyId?: string
  filters?: {
    page?: number
  }
  mapper?: (data: any) => T
}

export const useClientBillDynamicGroupables = <T,>({
  companyId,
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseClientBillDynamicGroupablesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientCompaniesBillDynamicGroupables', companyId, page],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${companyId}/bill_dynamic_groupables`, {
        params: {
          page,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
